<template>
  <div class="gallery-tile-container">
    <div class="tile" @click="$emit('slideshow')">
      <img :src="photo.url" class="image" :style="highlight"/>
      <transition name="pop">
        <div class="favourite-icon-animated" v-show="photo.favourite && animationInProgress"><i class="fa fa-heart"/></div>
      </transition>
      <div class="icons">
        <div class="favourite-icon" @click.stop="toggleFavourite(photo)">
          <i v-if="photo.favourite" class="fa fa-heart red"/>
          <i v-else class="far fa-heart no-favourite"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GalleryTile',
  props: {
    photo: {
      type: Object,
      required: true,
    },
    highlightFavourites: {
      type: Boolean,
      required: false,
    }
  },
  data() {
    return {
      animationInProgress: false,
      tapped: 'none',
    }
  },
  methods: {
    toggleFavourite(photo) {
      this.$emit('toggle-favourite', photo)
      this.animationInProgress = true
      setTimeout(() => this.animationInProgress = false, 490)
    },
  },
  computed: {
    highlight() {
      if(this.highlightFavourites && !this.photo.favourite)
        return { 
          filter: 'grayscale(100%)',
          opacity: 0.3
        }
      return {}
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/shared.scss';

.tile {
  display: inline-block;
  width: 100%;
  overflow: hidden;
  position: relative;
  cursor: pointer;
  border-radius: 10px;
  margin-bottom: 5px;
  @include shadow;
  transform: rotate(0); // needed to make border radius + transform child work

  &:hover {
    .icons .slideshow-icon {
      opacity: 1;
    }
  }

  .image {
    // width: 100%;
    max-width: 100%;
    max-height: 100%;
    transition: 0.3s all;
    display: block;

    // border-radius: 10px;
    
    &:hover {
      transform: scale(1.1);
    }
  }

  .favourite-icon-animated {
    position: absolute;
    top: 50%;
    right: 50%;
    transform: translate(50%, -50%);
    color: $red;
    // opacity: 0;
  }

  .icons {
    position: absolute;
    top: 0px;
    right: 0px;
    text-align: right;
    padding: 5px 10px;
    font-size: 20px;

    div {
      display:inline-block;
      margin-left: 5px;
    }

    .favourite-icon {
      color: white;
      transition: transform 0.1s;

      &:hover {
        transform: scale(1.2);
      }
    }
    .no-favourite {
      filter: drop-shadow(0px 0px 1px rgba(0, 0, 0, 0.7));
    }
  }
}

.highlight-favourites {
  filter: grayscale(100%);
}

.pop-enter-active {
  animation: pop-in 0.5s;
}
.pop-leave-active {
  // animation: pop-in .5s reverse;
  opacity: 0;
}
@keyframes pop-in {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    transform: scale(50);
    opacity: 0;
  }
}

</style>